import React from 'react';
import './SetupSystem.css'
import quochuy from '../../assets/img/Quoc_Huy_Viet_Nam_Chuan.png'
function SetupSystem () {
    
        return (
            <div>
                    <div className="">
  <div className="systemConfigContainer">
    
    <div className="systemConfigHeader">
      <div className="systemConfigHeaderLeft">
        <h2 className="systemConfigTitle">
          Cấu hình hệ thống
        </h2>

        <div className="systemConfigBreadcrumb">
          <span className="systemConfigBreadcrumbText">
            Trang chủ
          </span>

          <span className="systemConfigBreadcrumbSlash">
            /
          </span>

          <span className="systemConfigBreadcrumbActive">
            Cấu hình hệ thống
          </span>
        </div>
      </div>

      <div className="systemConfigHeaderRight">
        <button className="systemConfigSaveButton">
          <i className="fas fa-floppy-disk icon-floppy-disk"></i>
          Lưu cấu hình
        </button>
      </div>
    </div>

    <div className="systemConfigTabContainer">

      <div className="systemConfigTabActive">
        <i className="fas fa-gear"></i>
        Thông tin chung
      </div>

      <div className="systemConfigTabItem">
        <i className="fas fa-shield-halved"></i>
        Cấu hình bảo mật
      </div>

      <div className="systemConfigTabItem">
        <i className="fas fa-envelope"></i>
        Cấu hình email/SMS
      </div>

      <div className="systemConfigTabItem">
        <i className="fas fa-database"></i>
        Cấu hình sao lưu
      </div>

      <div className="systemConfigTabItem">
        <i className="fas fa-display"></i>
        Cấu hình hiển thị
      </div>

      <div className="systemConfigTabItem">
        <i className="fas fa-gear"></i>
        Thiết lập khác
      </div>

    </div>

    <div className="systemConfigContentRow">

      {/* <!-- LEFT --> */}

      <div className="systemConfigLeftBox">

        <div className="systemConfigCard">
          <h3 className="systemConfigCardTitle">
            Thông tin hệ thống
          </h3>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Tên hệ thống <span className="systemConfigRequired">*</span>
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="Hệ thống dữ liệu ngành Công Thương tỉnh An Giang"
            />
          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Tên viết tắt
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="DMS - AG"
            />
          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Logo hệ thống
            </label>

            <div className="systemConfigLogoBox">

              <div className="systemConfigLogoImage">
                <img
                  src={quochuy} className="quoc-huy"
                  alt=""
            
                />
              </div>

              <div className="systemConfigLogoInfo">
                <button className="systemConfigChooseFileButton">
                  Chọn file
                </button>

                <p className="systemConfigLogoText">
                  Định dạng: .png, .jpg, .jpeg. Kích thước tối đa 2MB
                </p>
              </div>

              <div className="systemConfigDeleteLogo">
                <i className="fas fa-trash-can"></i>
              </div>

            </div>
          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Mô tả hệ thống
            </label>

            <textarea className="systemConfigTextarea">
Hệ thống quản lý, lưu trữ, khai thác và chia sẻ dữ liệu ngành Công Thương tỉnh An Giang.
            </textarea>

            <div className="systemConfigTextCount">
              79/255
            </div>
          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Cơ quan chủ quản
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="Sở Công Thương tỉnh An Giang"
            />
          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Địa chỉ
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="09 Nguyễn Trãi, P. Mỹ Bình, TP. Long Xuyên, Tỉnh An Giang"
            />
          </div>

          <div className="systemConfigDoubleInput">

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Điện thoại
              </label>

              <input
                type="text"
                className="systemConfigInput"
                value="0296 3852 163"
              />
            </div>

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Email
              </label>

              <input
                type="text"
                className="systemConfigInput"
                value="sct@angiang.gov.vn"
              />
            </div>

          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Website
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="https://sct.angiang.gov.vn"
            />
          </div>

        </div>

      </div>

      {/* <!-- RIGHT --> */}

      <div className="systemConfigRightBox">

        <div className="systemConfigCardRight">
          <h3 className="systemConfigCardTitle">
            Cấu hình phiên làm việc
          </h3>

          <div className="systemConfigDoubleInput">

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Thời gian hết hạn phiên (phút)
                <span className="systemConfigRequired">*</span>
              </label>

              <input
                type="text"
                className="systemConfigInput"
                value="30"
              />

              <p className="systemConfigHint">
                Thời gian không thao tác sẽ tự động đăng xuất
              </p>
            </div>

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Số lần đăng nhập sai cho phép
                <span className="systemConfigRequired">*</span>
              </label>

              <input
                type="text"
                className="systemConfigInput"
                value="5"
              />

              <p className="systemConfigHint">
                Tài khoản sẽ bị khóa khi vượt quá số lần đăng nhập sai
              </p>
            </div>

          </div>

          <div className="systemConfigFormGroup">
            <label className="systemConfigLabel">
              Thời gian khóa tài khoản (phút)
              <span className="systemConfigRequired">*</span>
            </label>

            <input
              type="text"
              className="systemConfigInput"
              value="15"
            />

            <p className="systemConfigHint">
              Thời gian tài khoản bị khóa tạm thời
            </p>
          </div>

        </div>

        <div className="systemConfigCardBelow">
          <h3 className="systemConfigCardTitle">
            Cấu hình hệ thống
          </h3>

          <div className="systemConfigDoubleInput">

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Ngôn ngữ mặc định
              </label>

              <select className="systemConfigSelect">
                <option>Tiếng Việt</option>
              </select>
            </div>

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Số bản ghi mặc định/trang
              </label>

              <select className="systemConfigSelect">
                <option>10</option>
              </select>
            </div>

          </div>

          <div className="systemConfigDoubleInput">

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Định dạng ngày
              </label>

              <select className="systemConfigSelect">
                <option>dd/MM/yyyy</option>
              </select>
            </div>

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Định dạng số
              </label>

              <select className="systemConfigSelect">
                <option>1.234.567,89</option>
              </select>
            </div>

          </div>

          <div className="systemConfigDoubleInput">

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Múi giờ
              </label>

              <select className="systemConfigSelect time-zone">
                <option >(UTC+07:00) Bangkok, Hanoi, Jakarta</option>
              </select>
            </div>

            <div className="systemConfigHalfInput">
              <label className="systemConfigLabel">
                Bật chế độ bảo trì
              </label>

              <div className="systemConfigToggleBox">

                <p className="systemConfigToggleText">
                  Khi bật, hệ thống chỉ cho phép quản trị viên truy cập
                </p>

                <label className="systemConfigSwitch">
                  <input
                    type="checkbox"
                    className="systemConfigSwitchInput"
                  />

                  <span className="systemConfigSlider"></span>
                </label>

              </div>
            </div>

          </div>

        </div>

        <div className="systemConfigCardNoti">
          <h3 className="systemConfigCardTitle">
            Cấu hình thông báo
          </h3>

          <div className="systemConfigNotificationItem">

            <span className="systemConfigNotificationText">
              Cho phép thông báo trên hệ thống
            </span>

            <label className="systemConfigSwitch">
              <input
                type="checkbox"
                className="systemConfigSwitchInput"
                checked
              />

              <span className="systemConfigSlider"></span>
            </label>

          </div>

          <div className="systemConfigNotificationItem">

            <span className="systemConfigNotificationText">
              Cho phép thông báo qua email
            </span>

            <label className="systemConfigSwitch">
              <input
                type="checkbox"
                className="systemConfigSwitchInput"
                checked
              />

              <span className="systemConfigSlider"></span>
            </label>

          </div>

          <div className="systemConfigNotificationItem">

            <span className="systemConfigNotificationText">
              Cho phép thông báo qua SMS
            </span>

            <label className="systemConfigSwitch">
              <input
                type="checkbox"
                className="systemConfigSwitchInput"
              />

              <span className="systemConfigSlider"></span>
            </label>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>
            </div>
        );
    
}



export default SetupSystem;